import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { push } from 'react-router-redux'


class CategoryPageBoxes extends Component {
  constructor(props) {
    super(props);

  }

  handleCategoryBoxClick = (url) => {
    this.props.push(url);
  };

  handleCategoryLinkClick = (e) => {
    e.stopPropagation();
  };

  render() {
    const { categories, browser, categoryObj } = this.props;


    var maxNumberOfSubChildren = 5;
    var categoryChildren = '';
    var categorySubChildren = '';
    var categoryPageBoxClass = 'categoryPage-box';
    var innerClass = 'categoryPage-box-inner';
    var browserViewDir = '';
    if (browser.greaterThan.tablet) {
      browserViewDir = 'desktop';
    } else {
      browserViewDir = 'mobile';
    }

    // If the root category does not exists
    // this will break All category lps and listing pages.
    if (categoryObj == undefined) {
      return <span />;
    }

    var subCategories = categories.map((item) => {

      if (item.id == categoryObj.id) {

        if (item.children) {

          categoryChildren = item.children.map((categoryChild, idx) => {

            if (categoryChild.children) {
              categorySubChildren = categoryChild.children.map((categorySubChild, index) => {


                // If the number of sub children exceeds 5 add
                // class to reformat for full width on desktop
                if (index > maxNumberOfSubChildren) {
                  categoryPageBoxClass = 'categoryPage-box categoryPage-box-wide';
                }

                return (
                  <Link key={categorySubChild.path} className="link-styling" to={"/browse/" + categorySubChild.path}

                  onClick= {this.handleCategoryLinkClick}>

                  <div key={categorySubChild.id.toString()} className="categoryPage-categoryBtn-wrapper">
                    <div className="categoryPage-categoryBtn">
                      <div className="categoryPage-categoryBtn-name">
                        {categorySubChild.name}
                      </div>
                    </div>

                  </div></Link>

                );
              }); // End subChildren map


              // Test if sub category has children
              // If not we want to add class for vertically aligning
              // the sub category link.
              var numOfSubChildren = Object.keys(categorySubChildren).length;
              if (Object.keys(categorySubChildren).length == 0) {
                innerClass = innerClass + ' vertically-align';
              } else {
                innerClass = 'categoryPage-box-inner';
              }

            }


            return (

              <div key={categoryChild.id.toString()} className={categoryPageBoxClass} style={{'background-image': 'url(/images/categories/lp_sub_categories/' + item.slug +'/' + browserViewDir + '/' + categoryChild.slug + '.jpg)'}}
              >



                <div onClick={this.handleCategoryBoxClick.bind(null, "/browse/" + categoryChild.path)}



                 className="categoryPage-boxOverlay">
                  <div className={innerClass}>
                    <h3 className="categoryPage-categoryName">
                      {categoryChild.name.toUpperCase()}
                    </h3>

                    {categorySubChildren}
                  </div>
                </div>
              </div>

            );

          }); // End children map


        }

      } // End conditional test for categoryId



    }); // End subCategories map

    return <div className="categoryPage-boxes-wrapper">

        {categoryChildren}

    </div>

  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push
  }
)(CategoryPageBoxes);



// WEBPACK FOOTER //
// ./src/components/categoryDetailLandingPage/CategoryPageBoxes.jsx